import { slice } from './slice';

const { reducer } = slice;

export * from './thunks';
export * as bannersSelectors from './selectors';

export default reducer;
